import paymentsGuidePdf from 'assets/files/z-Connect - Payments.pdf';
import autoPaymentGuidePdf from 'assets/files/zConnect Autopayment Guide.pdf';
import revolutUserGuidePdf from 'assets/files/z-Connect - Payments (EU) _ Revolut.pdf';

export interface HelpCenterDocumentDefinition {
  id: string;
  title: string;
  summary: string;
  fileName: string;
  buildPdf: () => Promise<string>;
}

export const helpCenterDocuments: HelpCenterDocumentDefinition[] = [
  {
    id: 'payments-guide',
    title: 'Payments guide',
    summary:
      'The uploaded payments document, available for in-app review and download from the Help Center.',
    fileName: 'z-Connect - Payments.pdf',
    buildPdf: async () => paymentsGuidePdf,
  },
  {
    id: 'auto-payment-guide',
    title: 'ACH as payment method',
    summary:
      'The uploaded ACH payment document, available for in-app review and download from the Help Center.',
    fileName: 'zConnect Autopayment Guide.pdf',
    buildPdf: async () => autoPaymentGuidePdf,
  },
  {
    id: 'payment-user-guide',
    title: 'Revolut user guide',
    summary:
      'The uploaded Revolut user guide, available for in-app review and download from the Help Center.',
    fileName: 'z-Connect - Payments (EU) _ Revolut.pdf',
    buildPdf: async () => revolutUserGuidePdf,
  },
];
